import React, { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import DataTable from "react-data-table-component";
import CustomPagination from "./Pagination";
import CustomCheckbox from "./CustomCheckbox";
import { usePic } from "../context/PicProvider";

const DataTableComponent = ({
  title,
  data,
  columns,
  selectedRows,
  clickedRow,
  checkboxChange,
  search,
  searchBy = [],
  customStyles,
  placeholder,
}) => {
  const {
    searchQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    setShowSearch,
    setSearchPlaceholder,
  } = usePic();

  // const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(25);

  // Ensure data is an array
  if (!Array.isArray(data)) {
    data = [];
  }

  // Ensure searchBy is an array of strings
  const filteredData = data.filter((item) => {
    return searchBy.some((key) => {
      // Iterate over each key in the searchBy array
      const cellValue = item[key] || ""; // Access the value based on column name
      return cellValue
        .toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
    });
  });

  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleChange = (e) => {
    setItemsPerPage(Number(e.target.value));
  };

  const renderFrequencyOptions = () => {
    const pagePerOptions = [25, 50, 100, 150, 200];

    // Determine the filtered options based on totalItems
    const filteredOptions = [];
    for (let option of pagePerOptions) {
      const ratio = totalItems / option;
      if (ratio > 0 && totalItems / option === 1) {
        filteredOptions.push(option);
        break;
      }
      if (ratio <= 1) {
        filteredOptions.push(option);
        break;
      }
      filteredOptions.push(option);
    }
    return filteredOptions.map((page) => (
      <option key={page} value={page}>
        {page}
      </option>
    ));
  };

  useEffect(() => {
    setCurrentPage(1);
    setShowSearch(search);
    setSearchPlaceholder(placeholder);

    return () => {
      setSearchPlaceholder("");
      setShowSearch(false);
      if (searchQuery) {
        setSearchQuery("");
      }
    };
  }, [search]);

  return (
    <Card style={{ border: "none" }} className="h-100">
      <div
        // style={{ padding: "10px" }}
        className="flex-grow-1 d-flex flex-column row-gap-2"
      >
        <div className="d-flex align-items-center justify-content-between data-table-search gap-3 flex-wrap">
          <h3 className="card_title mb-0">{title}</h3>
          <Form.Group controlId="exampleForm.ControlFrequencyUnits">
            <Form.Select
              aria-label="Choose Frequency"
              name="frequency_units"
              value={itemsPerPage}
              onChange={handleChange}
            >
              <option value="" disabled className="option-title">
                List per page
              </option>
              {renderFrequencyOptions()}
            </Form.Select>
          </Form.Group>
        </div>
        <div className="position-relative flex-grow-1">
          <DataTable
            className="table_block"
            pagination={false}
            responsive
            fixedHeader
            highlightOnHover={true}
            selectableRowsHighlight={true}
            onRowClicked={clickedRow}
            onSelectedRowsChange={checkboxChange}
            columns={columns}
            customStyles={{
              table: {
                style: {
                  border: "1px solid white",
                },
              },
              headCells: {
                style: {
                  color: "#A8A8BD",
                  fontSize: 16,
                  fontWeight: 400,
                  whiteSpace: "nowrap",
                },
              },
              rows: {
                style: {
                  borderBottom: "1px solid #C5C5D3",
                  padding: "10px 0px",
                  color: "#16161D",
                  "&:hover": {
                    backgroundColor: "#e5f0ff !important",
                  },
                },
              },
              cells: {
                style: {
                  padding: "0px 8px",
                },
              },
              // rows: {
              //   style: {
              //     borderBottom: "1px solid #DADADA",
              //     color: "#333333",
              //     "&:hover": {
              //       backgroundColor: "#F5F5F5",
              //     },
              //     "&.selected": {
              //       backgroundColor: "#E3F2FD",
              //       color: "#1E88E5",
              //     },
              //   },
              // },
            }}
            data={currentItems}
            selectableRows={selectedRows}
            selectableRowsComponent={CustomCheckbox}
          />
        </div>
      </div>

      {/* Render custom pagination outside the scrolling div */}
      <CustomPagination
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        onFirstPage={() => setCurrentPage(1)}
        onLastPage={() => setCurrentPage(totalPages)}
      />
    </Card>
  );
};

export default DataTableComponent;
